module.exports = __webpack_public_path__ + "static/media/staffPermission.e8383525.png";